// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>
export const getLoading = state => state.issueVoucherReducer.loading;
export const getBookshopCustomer = state => state.issueVoucherReducer.bookshopCustomer;
export const getRequestStatus = state => state.issueVoucherReducer.requestStatus;
